import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Home from '../Home';
import { DEF_LANGUAGE, Language } from '../../constants';
import { translations, TranslationProvider } from '../../i18n';
import './style.css';

// TODO - read language from browser setting rather than hard-coding:

const App = () => {
  const [searchParams] = useSearchParams();
  const selectedLang = (searchParams.get('lang') || DEF_LANGUAGE) as Language;

  return (
    <div className="App" role="main">
      <TranslationProvider language={selectedLang} translations={translations}>
        <Home />
      </TranslationProvider>
    </div>
  );
};

export default App;
